/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_StateModel } from '../models/BigClock_Api_Models_StateModel';
import type { BigClock_Application_Queries_ReadUpsParams_ReadUpsParamsResponse } from '../models/BigClock_Application_Queries_ReadUpsParams_ReadUpsParamsResponse';
import type { BigClock_Application_Queries_ReadUpsStatistics_ReadUpsStatisticsResponse } from '../models/BigClock_Application_Queries_ReadUpsStatistics_ReadUpsStatisticsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UpsService {
    /**
     * @param upsId
     * @returns BigClock_Application_Queries_ReadUpsParams_ReadUpsParamsResponse Success
     * @throws ApiError
     */
    public static getApiUpsParams(
        upsId: string,
    ): CancelablePromise<BigClock_Application_Queries_ReadUpsParams_ReadUpsParamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ups/{upsId}/params',
            path: {
                'upsId': upsId,
            },
        });
    }
    /**
     * @param upsId
     * @returns BigClock_Application_Queries_ReadUpsStatistics_ReadUpsStatisticsResponse Success
     * @throws ApiError
     */
    public static getApiUpsStatistics(
        upsId: string,
    ): CancelablePromise<BigClock_Application_Queries_ReadUpsStatistics_ReadUpsStatisticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Ups/{upsId}/statistics',
            path: {
                'upsId': upsId,
            },
        });
    }
    /**
     * @param upsId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiUpsOutputState(
        upsId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Ups/{upsId}/output/state',
            path: {
                'upsId': upsId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param upsId
     * @returns any Success
     * @throws ApiError
     */
    public static postApiUpsOutputDisable(
        upsId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Ups/{upsId}/output/disable',
            path: {
                'upsId': upsId,
            },
        });
    }
}
